import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const miniCardsBlockDefaultVariants = {}
const miniCardsBlockCompoundVariants = []

const miniCardsBlockSlotNames = [
  [
    "root",
    "mini-cards-block__root"
  ]
]
const miniCardsBlockSlotFns = /* @__PURE__ */ miniCardsBlockSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, miniCardsBlockDefaultVariants, getSlotCompoundVariant(miniCardsBlockCompoundVariants, slotName))])

const miniCardsBlockFn = memo((props = {}) => {
  return Object.fromEntries(miniCardsBlockSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const miniCardsBlockVariantKeys = []
const getVariantProps = (variants) => ({ ...miniCardsBlockDefaultVariants, ...compact(variants) })

export const miniCardsBlock = /* @__PURE__ */ Object.assign(miniCardsBlockFn, {
  __recipe__: false,
  __name__: 'miniCardsBlock',
  raw: (props) => props,
  variantKeys: miniCardsBlockVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, miniCardsBlockVariantKeys)
  },
  getVariantProps
})